import {
  ADDRESS_CREATE_REQUEST_FAIL,
  ADDRESS_CREATE_REQUEST_SUCCESS,
  ADDRESS_DELETE_REQUEST_FAIL,
  ADDRESS_DELETE_REQUEST_SUCCESS,
  ADDRESS_UPDATE_REQUEST_FAIL,
  ADDRESS_UPDATE_REQUEST_SUCCESS,
  SELECT_ADDRESS
} from '../action.types';
import initialState from '../initial.state';

export default function(state = initialState.address, action) {
  switch (action.type) {
    case SELECT_ADDRESS:
      return { ...action.address };
    case ADDRESS_CREATE_REQUEST_SUCCESS:
      return { ...action.payload };
    case ADDRESS_CREATE_REQUEST_FAIL:
      return state;
    case ADDRESS_UPDATE_REQUEST_SUCCESS:
      return { ...action.payload };
    case ADDRESS_UPDATE_REQUEST_FAIL:
      return state;
    case ADDRESS_DELETE_REQUEST_SUCCESS:
      return state;
    case ADDRESS_DELETE_REQUEST_FAIL:
      return state;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/address/address.reducer.js